var React = require('react');

function WindowsWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,12.402l35.687,-4.86l0.016,34.423l-35.67,0.203l-0.033,-29.766Zm35.67,33.529l0.028,34.453l-35.67,-4.904l-0.002,-29.78l35.644,0.231Zm4.326,-39.025l47.318,-6.906l0,41.527l-47.318,0.376l0,-34.997Zm47.329,39.349l-0.011,41.34l-47.318,-6.678l-0.066,-34.739l47.395,0.077Z","style":{"fill":"#fff","fillRule":"nonzero"}}));
}

WindowsWhiteInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 88 88","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"className":"ark-svg"};

module.exports = WindowsWhiteInline;

WindowsWhiteInline.default = WindowsWhiteInline;
